

const MapSection = () => {
  return (
    <section className="w-full flex flex-col md:flex-row bg-[#E6F3CD] bg-opacity-50 shadow-2xl shadow-[#41220E]">
        <div className="w-full md:w-[50%] h-[600px] md:h-[700px] flex justify-center items-center">
            <div className="w-[70%] h-[80%] flex flex-col justify-center">
                <h1 className="font-bold font-playfair text-6xl lg:text-5xl text-[#41220E] mb-10 text-center md:text-start">Visit Us</h1>
                <div className="w-full bg-[#F5E9D7] border-solid border-2 border-[#D4A373] rounded-tl-[100px] rounded-br-[100px] text-center p-12">
                    <p className="font-medium font-playfair xs:text-lg text-2xl lg:text-3xl text-[#41220E]">
                        Symphonys Artisanal Bakery <br></br>
                        P.O.Box 16157 <br></br>
                        City Center Mall <br></br>
                        West Bay, <br></br>
                        Doha, Qatar <br></br>
                    </p>
                </div>
            </div>
        </div>
        <div className="w-full md:w-[50%] h-[400px] md:h-[700px] flex flex-col justify-center mb-[100px] md:py-0">
            <div style={{width: "100%"}}>
                <iframe 
                    width="100%" 
                    height="500" 
                    title="Map"
                    frameborder="0" 
                    scrolling="no" 
                    marginheight="0" 
                    marginwidth="0" 
                    src="https://maps.google.com/maps?width=100%25&amp;height=500&amp;hl=en&amp;q=P.O.Box%2016157,%20City%20Center%20Mall,%20West%20Bay,%20Doha,%20Qatar+(Symphonys%20Artisanal%20Bakery)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
                        <a href="https://www.gps.ie/">gps vehicle tracker</a>
                </iframe>
            </div>
        </div>
    </section>
  )
}

export default MapSection
